/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./favoriteselect.vue?vue&type=template&id=d0d492a6&scoped=true"
import script from "./favoriteselect.vue?vue&type=script&lang=js"
export * from "./favoriteselect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d492a6",
  null
  
)

export default component.exports